import { render, staticRenderFns } from "./TextAll.vue?vue&type=template&id=2fa8e3f8&scoped=true"
import script from "./TextAll.vue?vue&type=script&lang=js"
export * from "./TextAll.vue?vue&type=script&lang=js"
import style0 from "./TextAll.vue?vue&type=style&index=0&id=2fa8e3f8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa8e3f8",
  null
  
)

export default component.exports